import { en as extranetDataDisplayErrorPanel } from 'ViatoUi/Extranet/DataDisplay/ErrorPanel';
import { en as sharedFeedbackUserActionFeedback } from 'ViatoUi/Shared/Feedback/UserActionFeedback';

// Contains language vars that are the same across the entire application - like "back", "submit" etc.
const app = {
	feedback: {
		save: {
			error: 'Error while processing the data.',
			success: 'Your changes were saved successfully!'
		},
		data: {
			processing: 'Data is being processed.'
		}
	}
};

const en = {
	app,
	shared: {
		feedback: {
			userActionFeedback: sharedFeedbackUserActionFeedback
		}
	},
	extranet: {
		dataDisplay: {
			errorPanel: extranetDataDisplayErrorPanel
		}
	}
};

export default en;
